import { Generator } from "../types";

export const GeneratorOptions: Generator[] = [
  {
    features: [
      {
        name: "Outlet",
        parameters: [
          {
            name: "targetProject",
            type: "string",
          },
          {
            name: "targetFolder",
            type: "string",
          },
          {
            name: "libraryTargetFolder",
            type: "string",
          },
          {
            name: "skipLibraryFiles",
            type: "string",
          },
          {
            name: "apiTargetFolder",
            type: "string",
          },
        ],
      },
      {
        name: "LicenseHeader",
        parameters: [
          {
            name: "licenseText",
            type: "string",
          },
        ],
      },
      {
        name: "FunctionInlining",
        parameters: [
          {
            name: "inlineReactions",
            type: "boolean",
          },
          {
            name: "inlineEntryActions",
            type: "boolean",
          },
          {
            name: "inlineExitActions",
            type: "boolean",
          },
          {
            name: "inlineEnterSequences",
            type: "boolean",
          },
          {
            name: "inlineExitSequences",
            type: "boolean",
          },
          {
            name: "inlineChoices",
            type: "boolean",
          },
          {
            name: "inlineEnterRegion",
            type: "boolean",
          },
          {
            name: "inlineExitRegion",
            type: "boolean",
          },
          {
            name: "inlineEntries",
            type: "boolean",
          },
        ],
      },
      {
        name: "OutEventAPI",
        parameters: [
          {
            name: "observables",
            type: "boolean",
          },
          {
            name: "getters",
            type: "boolean",
          },
        ],
      },
      {
        name: "IdentifierSettings",
        parameters: [
          {
            name: "moduleName",
            type: "string",
          },
          {
            name: "statemachinePrefix",
            type: "string",
          },
          {
            name: "separator",
            type: "string",
          },
          {
            name: "headerFilenameExtension",
            type: "string",
          },
          {
            name: "sourceFilenameExtension",
            type: "string",
          },
        ],
      },
      {
        name: "Tracing",
        parameters: [
          {
            name: "enterState",
            type: "boolean",
          },
          {
            name: "exitState",
            type: "boolean",
          },
          {
            name: "generic",
            type: "boolean",
          },
        ],
      },
      {
        name: "Includes",
        parameters: [
          {
            name: "useRelativePaths",
            type: "boolean",
          },
          {
            name: "generateAllSpecifiedIncludes",
            type: "boolean",
          },
        ],
      },
      {
        name: "GeneratorOptions",
        parameters: [
          {
            name: "userAllocatedQueue",
            type: "boolean",
          },
          {
            name: "metaSource",
            type: "boolean",
          },
        ],
      },
      {
        name: "GeneralFeatures",
        parameters: [
          {
            name: "timerService",
            type: "boolean",
          },
          {
            name: "timerServiceTimeType",
            type: "string",
          },
        ],
      },
      {
        name: "Debug",
        parameters: [
          {
            name: "dumpSexec",
            type: "boolean",
          },
        ],
      },
    ],
    name: "C Generator",
    type: "create::c",
  },
  {
    features: [
      {
        name: "Outlet",
        parameters: [
          {
            name: "targetProject",
            type: "string",
          },
          {
            name: "targetFolder",
            type: "string",
          },
          {
            name: "libraryTargetFolder",
            type: "string",
          },
          {
            name: "skipLibraryFiles",
            type: "string",
          },
        ],
      },
      {
        name: "LicenseHeader",
        parameters: [
          {
            name: "licenseText",
            type: "string",
          },
        ],
      },
      {
        name: "FunctionInlining",
        parameters: [
          {
            name: "inlineReactions",
            type: "boolean",
          },
          {
            name: "inlineEntryActions",
            type: "boolean",
          },
          {
            name: "inlineExitActions",
            type: "boolean",
          },
          {
            name: "inlineEnterSequences",
            type: "boolean",
          },
          {
            name: "inlineExitSequences",
            type: "boolean",
          },
          {
            name: "inlineChoices",
            type: "boolean",
          },
          {
            name: "inlineEnterRegion",
            type: "boolean",
          },
          {
            name: "inlineExitRegion",
            type: "boolean",
          },
          {
            name: "inlineEntries",
            type: "boolean",
          },
        ],
      },
      {
        name: "OutEventAPI",
        parameters: [
          {
            name: "observables",
            type: "boolean",
          },
          {
            name: "getters",
            type: "boolean",
          },
        ],
      },
      {
        name: "Naming",
        parameters: [
          {
            name: "libraryPackage",
            type: "string",
          },
          {
            name: "basePackage",
            type: "string",
          },
          {
            name: "typeName",
            type: "string",
          },
        ],
      },
      {
        name: "GeneralFeatures",
        parameters: [
          {
            name: "RuntimeService",
            type: "boolean",
          },
          {
            name: "TimerService",
            type: "boolean",
          },
          {
            name: "VirtualTimerService",
            type: "boolean",
          },
          {
            name: "synchronized",
            type: "boolean",
          },
          {
            name: "runnable",
            type: "boolean",
          },
        ],
      },
      {
        name: "Tracing",
        parameters: [
          {
            name: "enterState",
            type: "boolean",
          },
          {
            name: "exitState",
            type: "boolean",
          },
          {
            name: "generic",
            type: "boolean",
          },
        ],
      },
      {
        name: "Debug",
        parameters: [
          {
            name: "dumpSexec",
            type: "boolean",
          },
        ],
      },
    ],
    name: "Java Generator",
    type: "create::java",
  },
  {
    features: [
      {
        name: "Outlet",
        parameters: [
          {
            name: "targetProject",
            type: "string",
          },
          {
            name: "targetFolder",
            type: "string",
          },
          {
            name: "libraryTargetFolder",
            type: "string",
          },
          {
            name: "skipLibraryFiles",
            type: "string",
          },
        ],
      },
      {
        name: "LicenseHeader",
        parameters: [
          {
            name: "licenseText",
            type: "string",
          },
        ],
      },
      {
        name: "FunctionInlining",
        parameters: [
          {
            name: "inlineReactions",
            type: "boolean",
          },
          {
            name: "inlineEntryActions",
            type: "boolean",
          },
          {
            name: "inlineExitActions",
            type: "boolean",
          },
          {
            name: "inlineEnterSequences",
            type: "boolean",
          },
          {
            name: "inlineExitSequences",
            type: "boolean",
          },
          {
            name: "inlineChoices",
            type: "boolean",
          },
          {
            name: "inlineEnterRegion",
            type: "boolean",
          },
          {
            name: "inlineExitRegion",
            type: "boolean",
          },
          {
            name: "inlineEntries",
            type: "boolean",
          },
        ],
      },
      {
        name: "OutEventAPI",
        parameters: [
          {
            name: "observables",
            type: "boolean",
          },
          {
            name: "getters",
            type: "boolean",
          },
        ],
      },
      {
        name: "Naming",
        parameters: [
          {
            name: "libraryPackage",
            type: "string",
          },
          {
            name: "basePackage",
            type: "string",
          },
        ],
      },
      {
        name: "GeneralFeatures",
        parameters: [
          {
            name: "DefaultTimer",
            type: "boolean",
          },
          {
            name: "RuntimeTemplate",
            type: "boolean",
          },
        ],
      },
      {
        name: "PyPackaging",
        parameters: [
          {
            name: "CreateFiles",
            type: "boolean",
          },
          {
            name: "Author",
            type: "string",
          },
          {
            name: "Version",
            type: "string",
          },
          {
            name: "ShortDescription",
            type: "string",
          },
          {
            name: "License",
            type: "string",
          },
          {
            name: "URL",
            type: "string",
          },
        ],
      },
      {
        name: "Debug",
        parameters: [
          {
            name: "dumpSexec",
            type: "boolean",
          },
        ],
      },
    ],
    name: "Python Generator",
    type: "create::python",
  },
  {
    features: [
      {
        name: "Outlet",
        parameters: [
          {
            name: "targetProject",
            type: "string",
          },
          {
            name: "targetFolder",
            type: "string",
          },
          {
            name: "libraryTargetFolder",
            type: "string",
          },
          {
            name: "skipLibraryFiles",
            type: "string",
          },
          {
            name: "apiTargetFolder",
            type: "string",
          },
        ],
      },
      {
        name: "LicenseHeader",
        parameters: [
          {
            name: "licenseText",
            type: "string",
          },
        ],
      },
      {
        name: "Debug",
        parameters: [
          {
            name: "dumpSexec",
            type: "boolean",
          },
        ],
      },
      {
        name: "FunctionInlining",
        parameters: [
          {
            name: "inlineReactions",
            type: "boolean",
          },
          {
            name: "inlineEntryActions",
            type: "boolean",
          },
          {
            name: "inlineExitActions",
            type: "boolean",
          },
          {
            name: "inlineEnterSequences",
            type: "boolean",
          },
          {
            name: "inlineExitSequences",
            type: "boolean",
          },
          {
            name: "inlineChoices",
            type: "boolean",
          },
          {
            name: "inlineEnterRegion",
            type: "boolean",
          },
          {
            name: "inlineExitRegion",
            type: "boolean",
          },
          {
            name: "inlineEntries",
            type: "boolean",
          },
        ],
      },
      {
        name: "OutEventAPI",
        parameters: [
          {
            name: "observables",
            type: "boolean",
          },
          {
            name: "getters",
            type: "boolean",
          },
        ],
      },
      {
        name: "IdentifierSettings",
        parameters: [
          {
            name: "moduleName",
            type: "string",
          },
          {
            name: "statemachinePrefix",
            type: "string",
          },
          {
            name: "separator",
            type: "string",
          },
          {
            name: "headerFilenameExtension",
            type: "string",
          },
          {
            name: "sourceFilenameExtension",
            type: "string",
          },
        ],
      },
      {
        name: "GeneratorOptions",
        parameters: [
          {
            name: "innerFunctionVisibility",
            type: "string",
          },
          {
            name: "staticOperationCallback",
            type: "boolean",
          },
          {
            name: "smartPointers",
            type: "boolean",
          },
        ],
      },
      {
        name: "Tracing",
        parameters: [
          {
            name: "enterState",
            type: "boolean",
          },
          {
            name: "exitState",
            type: "boolean",
          },
        ],
      },
      {
        name: "Includes",
        parameters: [
          {
            name: "useRelativePaths",
            type: "boolean",
          },
          {
            name: "generateAllSpecifiedIncludes",
            type: "boolean",
          },
        ],
      },
      {
        name: "GeneralFeatures",
        parameters: [
          {
            name: "timerService",
            type: "boolean",
          },
          {
            name: "timerServiceTimeType",
            type: "string",
          },
        ],
      },
    ],
    name: "C++ Generator",
    type: "create::cpp",
  },
  {
    features: [
      {
        name: "Outlet",
        parameters: [
          {
            name: "targetProject",
            type: "string",
          },
          {
            name: "targetFolder",
            type: "string",
          },
          {
            name: "libraryTargetFolder",
            type: "string",
          },
          {
            name: "skipLibraryFiles",
            type: "string",
          },
        ],
      },
      {
        name: "LicenseHeader",
        parameters: [
          {
            name: "licenseText",
            type: "string",
          },
        ],
      },
      {
        name: "Debug",
        parameters: [
          {
            name: "dumpSexec",
            type: "boolean",
          },
        ],
      },
      {
        name: "FunctionInlining",
        parameters: [
          {
            name: "inlineReactions",
            type: "boolean",
          },
          {
            name: "inlineEntryActions",
            type: "boolean",
          },
          {
            name: "inlineExitActions",
            type: "boolean",
          },
          {
            name: "inlineEnterSequences",
            type: "boolean",
          },
          {
            name: "inlineExitSequences",
            type: "boolean",
          },
          {
            name: "inlineChoices",
            type: "boolean",
          },
          {
            name: "inlineEnterRegion",
            type: "boolean",
          },
          {
            name: "inlineExitRegion",
            type: "boolean",
          },
          {
            name: "inlineEntries",
            type: "boolean",
          },
        ],
      },
      {
        name: "OutEventAPI",
        parameters: [
          {
            name: "getters",
            type: "boolean",
          },
        ],
      },
      {
        name: "GeneralFeatures",
        parameters: [
          {
            name: "TimerService",
            type: "boolean",
          },
        ],
      },
    ],
    name: "C# Generator",
    type: "create::csharp",
  },
];
